import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/index'
import Config from '../config/config-1.js'
// import notFour from '@/components/404'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: Config.basePath,
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/index',
      meta: {
        title: "碳达人•惠湖州"
      },
    },
    {
      path: '/test',
      name: 'index',
      meta: {
        title: "首页",
        keepAlive: true
      },
      component: Home
    },
    {
      path: '/Home',
      name: 'Home',
      meta: {
        title: "首页",
        keepAlive: true
      },
      component: resolve => require(['@/views/home.vue'], resolve)
    },
    {
      path: '/carbonNeutral/app/carbonHuihuzhou/talentAssistant',
      name: 'talentAssistant',
      meta: {
        title: "达人助手",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/talentAssistant/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonSL/carbonSLagree',
      name: 'carbonSLagree',
      meta: {
        title: "用户授权协议",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/carbonSL/carbonSLagree.vue'], resolve)
    },
    // {
    //   path: '/carbonHuihuzhou/view/carbonMeeting',
    //   name: 'carbonMeeting',
    //   meta: {
    //     title: "计算器会议",
    //     keepAlive: true
    //   },
    //   component: resolve => require(['@/views/carbonHuihuzhou/view/carbonMeeting/index.vue'], resolve)
    // },
    // { // 静态页面
    //   path: '/carbonHuihuzhou/view/welfareObject2',
    //   name: 'welfareObject2',
    //   meta: {
    //     title: "公益项目",
    //     keepAlive: true
    //   },
    //   component: resolve => require(['@/views/carbonHuihuzhou/view/welfareObject2/index.vue'], resolve)
    // },
    {
      path: '/carbonHuihuzhou/view/welfareObject',
      name: 'welfareObject',
      meta: {
        title: "公益项目",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/welfareObject/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/welfareObject/cancelActivity',
      name: 'cancelActivity',
      meta: {
        title: "取消活动",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/welfareObject/cancelActivity.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/welfareObject/img',
      name: 'welfareObjectImg',
      meta: {
        title: "选择公益背景图",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/welfareObject/img.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/welfareObject/myGlory',
      name: 'welfareObjectMyGlory',
      meta: {
        title: "我的荣耀",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/welfareObject/myGlory.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/welfareObject/news',
      name: 'welfareObjectNews',
      meta: {
        title: "消息通知",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/welfareObject/news.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/welfareObject/agree',
      name: 'welfareObjectAgree',
      meta: {
        title: "服务协议",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/welfareObject/agree.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/helpDetail',
      name: 'helpDetail',
      meta: {
        title: "公益项目详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/welfareObject/helpDetail.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/dynamic',
      name: 'dynamic',
      meta: {
        title: "参加人数",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/welfareObject/dynamic.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/dynamicZc',
      name: 'dynamicZc',
      meta: {
        title: "公益项目支持动态",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/welfareObject/dynamicZc.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/busTravel',
      name: 'photovoltaic',
      meta: {
        title: "公交出行",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/busTravel/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/photovoltaic',
      name: 'photovoltaic',
      meta: {
        title: "户用光伏",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/photovoltaic/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/photovoltaicDetail',
      name: 'photovoltaicDetail',
      meta: {
        title: "户用光伏",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/photovoltaic/photovoltaicDetail.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/photovoltaic/nonOwner',
      name: 'photovoltaicNonOwner',
      meta: {
        title: "非业主户用光伏",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/photovoltaic/nonOwner.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/refuse',
      name: 'refuse',
      meta: {
        title: "垃圾分类",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/refuse/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/greenCar',
      name: 'greenCar',
      meta: {
        title: "零碳车主",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/greenCar/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/airConditioner',
      name: 'airConditioner',
      meta: {
        title: "智能空调",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/airConditioner/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/citizenCard',
      name: 'citizenCard',
      meta: {
        title: "湖州市民卡",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/citizenCard/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/citizenCardDetail',
      name: 'citizenCardDetail',
      meta: {
        title: "湖州市民卡详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/citizenCard/detail.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/greenCarDetail',
      name: 'greenCar',
      meta: {
        title: "零碳车主详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/greenCar/greenCarDetail.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/greenCar/agree',
      name: 'greenCaragree',
      meta: {
        title: "减碳承诺书",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/greenCar/agree.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/greenCar/agreeOne',
      name: 'greenCaragree1',
      meta: {
        title: "个人信息授权",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/greenCar/agree1.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/dribble',
      name: 'dribble',
      meta: {
        title: "碳惠水滴",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/dribble/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/sellCarbon',
      name: 'sellCarbon',
      meta: {
        title: "去赚钱",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/sellCarbon/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/sellCarbonYsf',
      name: 'sellCarbonYsf',
      meta: {
        title: "去赚钱",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/sellCarbon/indexYsf.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/sellBuy',
      name: 'goBuy',
      meta: {
        title: "去出售详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/sellCarbon/components/goBuy/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/onSall',
      name: 'onSall',
      meta: {
        title: "在售",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/sellCarbon/components/myBuy/onSall.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/onSold',
      name: 'onSold',
      meta: {
        title: "已售",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/sellCarbon/components/myBuy/onSold.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/buyCarbon',
      name: 'buyCarbon',
      meta: {
        title: "去买碳",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/buyCarbon/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/goBuy',
      name: 'goBuy',
      meta: {
        title: "去买碳详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/buyCarbon/components/goBuy/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/search',
      name: 'search',
      meta: {
        title: "搜索",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/buyCarbon/components/goBuy/search.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/newsCneter',
      name: 'newsCneter',
      meta: {
        title: "去买碳消息",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/buyCarbon/components/newsCneter/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/newsCneterSall',
      name: 'newsCneter',
      meta: {
        title: "去出售消息",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/sellCarbon/components/newsCneter/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/myBuy',
      name: 'myBuy',
      meta: {
        title: "我的买入",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/buyCarbon/components/myBuy/index.vue'], resolve)
    },
    // {
    //   path: '/carbonHuihuzhou/view/sink',
    //   name: 'sink',
    //   meta: {
    //     title: "我的碳汇",
    //     keepAlive: true
    //   },
    //   component: resolve => require(['@/views/carbonHuihuzhou/view/buyCarbon/components/myBuy/sink.vue'], resolve)
    // },
    // {
    //   path: '/carbonHuihuzhou/app/carbonMeeting/detail',
    //   name: 'carbonMeetingdetail',
    //   meta: {
    //     title: "计算器会议详情",
    //     keepAlive: true
    //   },
    //   component: resolve => require(['@/views/carbonHuihuzhou/view/carbonMeeting/detail.vue'], resolve)
    // },
    // {
    //   path: '/carbonHuihuzhou/app/carbonMeeting/addOrEdit',
    //   name: 'carbonMeetingaddOrEdit',
    //   meta: {
    //     title: "计算器会议发布",
    //     keepAlive: true
    //   },
    //   component: resolve => require(['@/views/carbonHuihuzhou/view/carbonMeeting/addOrEdit.vue'], resolve)
    // },
    {
      path: '/carbonNeutral/app/carbonHuihuzhou/personalCenter',
      name: 'personalCenterHuihuzhou',
      meta: {
        title: "个人中心",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/personalCenter/index.vue'], resolve)
    },
    {
      path: '/carbonNeutral/app/carbonHuihuzhou/carbonDetails',
      name: 'carbonDetails',
      meta: {
        title: "碳积分明细",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/personalCenter/carbonDetails.vue'], resolve)
    },
    ,
    {
      path: '/carbonNeutral/app/carbonHuihuzhou/reductionDetails',
      name: 'carbonDetails',
      meta: {
        title: "碳排量明细",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/personalCenter/reductionDetails.vue'], resolve)
    },
    {
      path: '/carbonNeutral/app/carbonHuihuzhou/applyMoney',
      name: 'applyMoney',
      meta: {
        title: "我的钱包申请",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/myMoney/applyMoney.vue'], resolve)
    },
    {
      path: '/carbonNeutral/app/carbonHuihuzhou/myMoney',
      name: 'myMoney',
      meta: {
        title: "我的钱包",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/myMoney/myMoney.vue'], resolve)
    },
    {
      path: '/carbonNeutral/app/carbonHuihuzhou/moneyDetail',
      name: 'moneyDetail',
      meta: {
        title: "我的钱包详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/myMoney/moneyDetail.vue'], resolve)
    },
    // -------------------  没用到  ----------------
    // {
    //   path: '/carbonNeutral/app/carbonHuihuzhou/iframe', // 有可能是组件
    //   name: 'iframe',
    //   meta: {
    //     title: "我的钱包",
    //     keepAlive: true
    //   },
    //   component: resolve => require(['@/views/carbonHuihuzhou/view/myMoney/iframe.vue'], resolve)
    // },
    // 个人中心—我要认证—选择角色
    // {
    //   path: '/carbonHuihuzhou/myCertification/selectUser',
    //   name: 'selectUser',
    //   meta: {
    //     title: "选择角色",
    //     keepAlive: true
    //   },
    //   component: resolve => require(['@/views/carbonHuihuzhou/view/myCertification/selectUser.vue'], resolve)
    // },
    // {
    //   path: '/carbonHuihuzhou/myCertification/authentication',
    //   name: 'authentication',
    //   meta: {
    //     title: "认证",
    //     keepAlive: true
    //   },
    //   component: resolve => require(['@/views/carbonHuihuzhou/view/myCertification/authentication.vue'], resolve)
    // },
    // {
    //   path: '/carbonHuihuzhou/myCertification/addOrEdit',
    //   name: 'addOrEditRZ',
    //   meta: {
    //     title: "资料登记",
    //     keepAlive: true
    //   },
    //   component: resolve => require(['@/views/carbonHuihuzhou/view/myCertification/addOrEdit.vue'], resolve)
    // },
    // {
    //   path: '/carbonHuihuzhou/myCertification/onSubmit',
    //   name: 'myCertificationSubmit',
    //   meta: {
    //     title: "提交",
    //     keepAlive: true
    //   },
    //   component: resolve => require(['@/views/carbonHuihuzhou/view/myCertification/onSubmit.vue'], resolve)
    // },
    // -------------------  没用到 end  ----------------
    // // 分类卡 - 后续会用
    // {
    //   path: '/carbonHuihuzhou/view/classificationList',
    //   name: 'classificationList',
    //   meta: {
    //     title: "分类卡-我的绑定",
    //     keepAlive: true
    //   },
    //   component: resolve => require(['@/views/carbonHuihuzhou/view/classification/index.vue'], resolve)
    // },
    // {
    //   path: '/carbonHuihuzhou/view/classificationAdd',
    //   name: 'classificationAdd',
    //   meta: {
    //     title: "分类卡绑定",
    //     keepAlive: true
    //   },
    //   component: resolve => require(['@/views/carbonHuihuzhou/view/classification/add.vue'], resolve)
    // },
    {
      path: '/carbonHuihuzhou/view/benefitsCenter',
      name: 'benefitsCenter',
      meta: {
        title: "福利中心",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/benefitsCenter/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/benefitsCenter/news',
      name: 'benefitsCenterNews',
      meta: {
        title: "消息中心",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/benefitsCenter/news.vue'], resolve)
    },
     // 积分转赠
     {
      path: '/carbonHuihuzhou/view/pointsTransfer',
      name: 'pointsTransfer',
      meta: {
        title: "积分转让",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/pointsTransfer/index.vue'], resolve)
    },
    // 积分抽奖首页
    {
      path: '/carbonHuihuzhou/view/pointsLottery',
      name: 'pointsLottery',
      meta: {
        title: "积分抽奖",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/benefitsCenter/pointsLottery.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/pointsLotteryDetail',
      name: 'pointsLotteryDetail',
      meta: {
        title: "积分抽奖详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/benefitsCenter/components/pointsLottery/pointsLotteryDetail.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/pointsLotteryDetailNew',
      name: 'pointsLotteryDetail',
      meta: {
        title: "积分抽奖详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/benefitsCenter/components/pointsLottery/pointsLotteryDetailNew.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/winningRecord',
      name: 'winningRecord',
      meta: {
        title: "中奖记录",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/benefitsCenter/components/pointsLottery/winningRecord.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/mine',
      name: 'mineBenefits',
      meta: {
        title: "我的福利",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/benefitsCenter/mine.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/benefitsCenter/huzhouView',
      name: 'huzhouView',
      meta: {
        title: "我的福利",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/benefitsCenter/components/mine/huzhouView.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/benefitsCenter/unlocking',
      name: 'mineUnlocking',
      meta: {
        title: "功能解锁",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/benefitsCenter/unlocking.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/confirmOrder',
      name: 'mineBenefits',
      meta: {
        title: "确认订单",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/confirmOrder/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/confirmOrder/address',
      name: 'address',
      meta: {
        title: "添加地址",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/confirmOrder/address.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/orderDetail',
      name: 'orderDetail',
      meta: {
        title: "订单详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/confirmOrder/components/orderDetail.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/electronicVoucherDetails',
      name: 'electronicVoucherDetails',
      meta: {
        title: "电子券详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/benefitsCenter/electronicVoucherDetails.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/view/practicalityVoucherDetails',
      name: 'practicalityVoucherDetails',
      meta: {
        title: "商品详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/view/benefitsCenter/practicalityVoucherDetails.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/toBuyCarbon',
      name: 'toBuyCarbon',
      meta: {
        title: "去买碳",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/toBuyCarbon/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/toBuyCarbon/market',
      name: 'toBuyCarbonMarket',
      meta: {
        title: "碳汇市场",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/toBuyCarbon/market.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/toBuyCarbon/purchase',
      name: 'toBuyCarbonPurchase',
      meta: {
        title: "去购买",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/toBuyCarbon/purchase.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/toBuyCarbon/submit',
      name: 'toBuyCarbonSubmit',
      meta: {
        title: "去购买成功",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/toBuyCarbon/submit.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/earnCash',
      name: 'toBuyCarbon',
      meta: {
        title: "赚现金",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/earnCash/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/earnCash/purchase',
      name: 'earnCashPurchase',
      meta: {
        title: "赚现金去出售",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/earnCash/purchase.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/earnCash/agree',
      name: 'earnCashAgree',
      meta: {
        title: "委托出售服务协议",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/earnCash/agree.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/earnCash/submit',
      name: 'earnCashSubmit',
      meta: {
        title: "委托出售成功",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/earnCash/submit.vue'], resolve)
    },
    // {
    //   path: '/404',
    //   name: '404',
    //   meta: {
    //     title: "404"
    //   },
    //   component: notFour
    // }
    {
      path: '/carbonHuihuzhou/carbonMini/eTicket/e-ticket-detail',
      name: 'eTicketDetail',
      meta: {
        title: "电子券详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/eTicket/e-ticket-detail.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/eTicket/confirmExchange',
      name: 'confirmExchange',
      meta: {
        title: "确认兑换",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/eTicket/confirm-exchange.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/eTicket/exchangeSuccess',
      name: 'exchangeSuccess',
      meta: {
        title: "兑换成功",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/eTicket/exchange-success.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/eTicket/eTicketOrderDetail',
      name: 'eTicketOrderDetail',
      meta: {
        title: "电子券订单详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/eTicket/e-ticket-order-detail.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/eTicket/seckillList',
      name: 'seckillList',
      meta: {
        title: "限时秒杀",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/seckill/seckill-list.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/eTicket/seckillDetail',
      name: 'seckillDetail',
      meta: {
        title: "秒杀详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/seckill/seckill-detail.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/seckill/confirmSeckill',
      name: 'confirmSeckill',
      meta: {
        title: "确认秒杀",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/seckill/confirm-seckill.vue'], resolve)
    },
    // {
    //   path: '/carbonHuihuzhou/carbonMini/home/addToDesktop',
    //   name: 'addToDesktop',
    //   meta: {
    //     title: "添加碳达人服务到桌面",
    //     keepAlive: true
    //   },
    //   component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/home/add-to-desktop.vue'], resolve)
    // },
    {
      path: '/carbonHuihuzhou/carbonMini/blog/add',
      name: 'blogAdd',
      meta: {
        title: "投稿",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/blog/add.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/blog/list',
      name: 'blogList',
      meta: {
        title: "投稿列表",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/blog/list.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/blog/detail',
      name: 'blogDetail',
      meta: {
        title: "投稿详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/blog/detail.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/vote/detail',
      name: 'voteDetail',
      meta: {
        title: "投票详情",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/blog/detail-vote.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/answer/index',
      name: 'answerIndex',
      meta: {
        title: "快乐答题",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/answer/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/answer/answer',
      name: 'answer',
      meta: {
        title: "答题界面",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/answer/answer.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/answer/point',
      name: 'answerPoint',
      meta: {
        title: "答题得分",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/answer/point.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/myBenefits',
      name: 'myBenefits',
      meta: {
        title: "我的福利",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/benefitsCenter/my-benefits.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/merchantSettle',
      name: 'merchantSettle',
      meta: {
        title: "商户入驻",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/merchantSettle/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/feedback',
      name: 'feedback',
      meta: {
        title: "意见反馈",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/feedback/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/forecast',
      name: 'forecast',
      meta: {
        title: "猜一猜碳排",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/forecast/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/calculator',
      name: 'carbonCalculator',
      meta: {
        title: "碳计算器",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/calculator/pages/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/calculator/personnel',
      name: 'personnelCalculator',
      meta: {
        title: "个人碳计算器",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/calculator/pages/personnel.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/calculator/business',
      name: 'businessCalculator',
      meta: {
        title: "机构碳计算器",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/calculator/pages/business.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/result',
      name: 'carbonResult',
      meta: {
        title: "碳排量",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/calculator/pages/result.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/resultList',
      name: 'carbonResultList',
      meta: {
        title: "碳足迹",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/calculator/pages/result-list.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/greenCarSuccess',
      name: 'greenCarSuccess',
      meta: {
        title: "零碳车主认证成功",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/home/green-car-success.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/hexiao',
      name: 'hexiao',
      meta: {
        title: "商品核销",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/merchantSettle/hexiao.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/receive/:key',
      name: 'receive',
      meta: {
        title: "领取转赠积分",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/present/receive.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/carbonSinkMarket/index',
      name: 'hexiao',
      meta: {
        title: "碳汇市场",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/carbonSinkMarket/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/carbonSinkMarket/purchase',
      name: 'hexiao',
      meta: {
        title: "碳汇市场-买入",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/carbonSinkMarket/purchase.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/carbonSinkMarket/record',
      name: 'hexiao',
      meta: {
        title: "碳汇市场-交易记录",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/carbonSinkMarket/record.vue'], resolve)
    },
    // 科技馆
    {
      path: '/carbonHuihuzhou/carbonMini/museumCarbonEmission',
      name: 'museumCarbonEmission',
      meta: {
        title: "科技馆",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/museumCarbonEmission/index.vue'], resolve)
    },
    {
      path: '/carbonHuihuzhou/carbonMini/clock/detail',
      name: 'hexiao',
      meta: {
        title: "打卡大挑战详情页",
        keepAlive: true
      },
      component: resolve => require(['@/views/carbonHuihuzhou/carbonMini/clock/detail.vue'], resolve)
    }
  ]
})
//全局前置守卫
router.beforeEach((to, from, next) => {
  // console.log('to -----------', to)
  // console.log('from -----------', from)
  if (sessionStorage.getItem('goBack') === "vue") {
    window.location.replace(Config.basePath + '/static/home2.html')
    return;
  }
  // if (sessionStorage.getItem('goBack') === "vue1") {
  //   window.location.replace('/static/confirm.html')
  //   return;
  // }

  if (sessionStorage.getItem('unlockingHome')) {
    next({ ...to.query.path, replace: true })
    return;
  }
  if (to.query.path) {
    next(to.query.path);
    return
  }
  // 没有用户信息时跳到login
  // var userInfo = localStorage.getItem("userInfo");
  // if (!userInfo && userInfo === "{}") {
  //     next("/login");
  //     return;
  // }
  // if (to.path === "/") {
  //   next("/login");
  //   return;
  // }
  // if (to.path === "/admin") {
  //     next("/login");
  //     return;
  // }
  if (to.matched.length === 0) { // 如果未匹配到路由
    // next('/404')
  } else {
    next() // 如果匹配到正确跳转
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js